














import { defineComponent, ref, computed, PropType } from '@nuxtjs/composition-api';
import StaffProductCard from '~/components/pages/Staff/StaffProductCard.vue';
import AppSeeMoreButton from '~/components/partials/App/AppSeeMoreButton.vue';
import { REVIEWS_PER_PAGE } from '~/constants';
import { StaffReviewProduct } from '~/types/modules/staff';

export default defineComponent({
  components: {
    AppSeeMoreButton,
    StaffProductCard,
  },
  props: {
    products: {
      type: Array as PropType<StaffReviewProduct[]>,
      default: () => [],
    },
  },
  setup(props) {
    const pagination = ref(1);
    const isLoadMoreButtonVisible = computed(() => props.products.length > pagination.value * REVIEWS_PER_PAGE);

    const filteredItems = computed(() => {
      return props.products.slice(0, pagination.value * REVIEWS_PER_PAGE);
    });

    return {
      pagination,
      isLoadMoreButtonVisible,
      filteredItems,
    };
  },
});
